import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom'

import { NewExpenseOcrModalPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import NewExpenseOcrModal from 'modules/expenses/components/expenses/New/ExpenseOcrModal'
import type { RouteContextParams } from 'modules/expenses/lib/my_expenses/RouteContextParams'

const NewExpenseOcrModalPage = () => {
  const navigate = useNavigate()
  const { back } = useOutletContext<RouteContextParams>()

  const { data, loading } = useQuery(NewExpenseOcrModalPageDocument)

  const signedDocumentsTerms = data?.expenses?.signedDocumentsTermsConnection?.totalCount ?? 0
  const [searchParams] = useSearchParams()

  if (loading) return <Loading inline />

  return (
    <NewExpenseOcrModal
      signedDocumentsTerms={signedDocumentsTerms}
      onClose={() => navigate({ pathname: back.href, search: searchParams.toString() })}
    />
  )
}

export default NewExpenseOcrModalPage
